module.exports = __webpack_public_path__ + "static/media/2_ellipse.0156ee85.svg";